;(function () {
  'use strict'
  angular
    .module('contrast.navigation.history')
    .factory('HistoryService', [
      '$rootScope',
      '$location',
      '$route',
      '$routeSegment',
      '$routeParams',
      HistoryService
    ])

  function HistoryService(
    $rootScope,
    $location,
    $route,
    $routeSegment,
    $routeParams
  ) {
    var history = []

    return {
      init: init,
      getHistory: getHistory,
      goBack: goBack,
      getBackUrl
    }

    function init() {
      var deregister = $rootScope.$on('$routeChangeSuccess', function () {
        history.push($location.path())
      })
      return deregister
    }

    function getHistory() {
      return history
    }

    function goBack(currentPath, backupPathGetter) {
      for (var i = history.length - 1; i >= 0; i--) {
        if (history[i].indexOf(currentPath) === -1) {
          $location.path(history[i])
          return
        }
      }
      $location.path(backupPathGetter($route.current.params))
    }

    function getBackUrl(routeSegment) {
      return `${$routeSegment.getSegmentUrl(routeSegment, $routeParams)}${
        $location.url().includes('?') ? `?${$location.url().split('?')[1]}` : ''
      }`
    }
  }
})()
